// ~/common/abilities/Ability.ts
import {
  AbilityBuilder,
  createMongoAbility,
  MongoAbility,
} from '@casl/ability';
import { RolesEnum } from '~/roles/types';

// Define action and subject types
export type Actions = 'Manage';
export type Subjects = 'All';

// Create a type for the ability
export type AppAbility = MongoAbility;

// Function to define abilities for a user
export function defineAbilitiesFor(user: {
  roles: string[];
  permissions: string[];
  features: Record<string, any>;
}) {
  const { can, rules } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (user.roles.includes(RolesEnum.SUPER_ADMIN)) {
    // SuperAdmin has full access
    can('Manage', 'All');
  } else {
    if (user.roles.includes(RolesEnum.ADMIN)) {
      // Company Admin can manage company
      can('Manage', 'Company');
    }
  }

  // Define abilities based on permissions
  user.permissions.forEach((permission) => {
    const [action, subject] = permission.split(':') as [Actions, Subjects];
    can(action, subject);
  });

  Object.entries(user.features).forEach(([feature, featureSettings]) => {
    can('Access', feature);

    featureSettings.settings?.forEach((setting: any) => {
      if (setting.value === true) {
        //only check boolean
        can('Access', setting.key);
      }
    });
  });

  // Return the rules defined
  return rules;
}
